import React from "react";
import { Icon } from "@iconify/react";
import "./MyCart.css";
function Mycartcontent() {
  return (
    <div>
      <div className="my-cart-content">
        <div className="row">
          <div className="col-lg-7 col-12">
            <div className="row">
              <div className="col-lg-8 col-12 item-detail-left heelo ">
                <div className="cart-content-head cart-item-head bdr-r">
                  <h4>Item</h4>
                </div>

                <div className="item-content bdr-r ">
                  <div className="item-img me-3">
                    <img src="\image\item1.png" alt="" />
                  </div>

                  <div className="item-detail ">
                    <div className="item-name">
                      <h3>Moon Rabbit Store</h3>
                      <h5>Moon Rabbits (USA)</h5>
                    </div>

                    <div className="item-details">
                      <p>New Rocket Bunny Men’s T-Shirt</p>
                    </div>

                    <div className="item-color">
                      <p>Color : </p>

                      <img src="\image\img-color.svg" alt="" />
                    </div>

                    <div className="item-size">
                      <p>Size : </p>
                      <p>S</p>
                    </div>

                    <div className="item-stock">
                      <p>In Stock</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-2 col-12 item-detail-left   bdr-r">
                <div className="cart-content-head text-center eachx">
                  <h4>Each</h4>
                </div>
                <div className="item-content-each d-flex">
                  <p>500 SOL</p>
                </div>
              </div>

              <div className="col-lg-2 col-12 item-detail-left   bdr-r">
                <div className="cart-content-head text-center">
                  <h4>Quantity</h4>
                </div>
                <div className="item-content-each d-flex">
                  <div className="wrapper">
                    <button className="minus">-</button>
                    <p className="num">1</p>
                    <button className="plus">+</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-5 col-12 item-detail-right  ">
            <div className="row h-100">
              <div className="col-lg-2 col-12 item-detail-left   bdr-r">
                <div className="cart-content-head text-center">
                  <h4>Total</h4>
                </div>

                <div className="item-content-each  ">
                  <p>600 SOL</p>
                </div>
              </div>

              <div className="col-lg-8 col-12 item-detail-left     bdr-r">
                <div className="cart-content-head text-center">
                  <h4>Shipping Detail</h4>
                </div>
                <div className="shipping">
                  <div className="ship-detail">
                    <div className="Shipping-Cost sett">
                      <p>Shipping Cost</p>
                      <p>TBD</p>
                    </div>
                    <div className="Shipping-Discount sett">
                      <p> Discount</p>
                      <p>-$0</p>
                    </div>
                    <div className="Shipping-tax sett">
                      <p>Tax</p>
                      <p>TBD</p>
                    </div>
                  </div>
                  <hr className="my-4" />
                  <div className="ship-total">
                    <div className=" sett">
                      <p>Estimated Total</p>
                      <p>600 SOL</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-2 col-12 item-detail-left">
                <div className="cart-content-head text-center">
                  <h4>Action</h4>
                </div>
                <div className="item-dlt ">
                  <Icon
                    icon="ant-design:delete-filled"
                    color="#fb6f6f"
                    width="32"
                    height="32"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Mycartcontent;
